import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
import Vue from 'vue';
var axios_intsace_get_claims_ess = get_axios_instance(api_variables.SERVICE_FBP_DECLARATION_CLAIMS_ESS)
var axios_intsace_get_claims_history_ess = get_axios_instance(api_variables.SERVICE_FBP_DECLARATION_CLAIMS_HISTORY_ESS)
var axios_intsace_post_new_claims_ess = get_axios_instance(api_variables.SERVICE_FBP_ADD_NEW_CLAIMS_ESS)
const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters={
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record
    }
}
const mutations={
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
    setRecord: (state, payload) => {
        state.record = payload.record;
    }
}
const actions={
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_intsace_get_claims_ess.get(``, {
                params:
                {
                    le_id: payload.le_id,
                    emp_id: payload.emp_id,
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setRecord", [res.data.payload, payload]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async fetchAllClaimsHistory({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_intsace_get_claims_history_ess.get(`/${payload}`);
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setRecord", [res.data.payload, payload]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async addNewClaims({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_intsace_post_new_claims_ess.post(`/`,
                payload
            );
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setRecord", [res.data.payload, payload]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
}
export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}